import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from '../Components/login-page/login-page.component';

@Injectable({
  providedIn: 'root'
})
export class BackEndService {
  httpOptions = {
    headers: new HttpHeaders(
      {
        'Content-Type': 'application/json',
      }
    )
  };

  constructor(private http: HttpClient) { }
  GetFolders(): Observable<any> {
    return this.http.get<any>('https://partner.fibudata.net/Code.php');
  }
  DownloadFile(str: string) {
    return this.http.post('https://partner.fibudata.net/downloadFile.php', str, this.httpOptions);
  }
  LogIn(user: User) {

    JSON.stringify(user)
    return this.http.post('https://partner.fibudata.net/Authentication.php', JSON.stringify(user));
  }

}
